module.exports = __webpack_public_path__ + "img/44.2730c341.jpg";